module.exports = __webpack_public_path__ + "img/ring_skip_0_1_1@2x.4ad8675b.png";